var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComoros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9995 15.9539H14.6551C11.2116 19.3975 9.12918 22.0561 7.00293 24.1823L16.0464 24.9973L30.0798 23.606C31.3045 21.3438 32.0001 18.7533 32.0001 16.0002C32.0001 15.9847 31.9995 15.9694 31.9995 15.9539V15.9539Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00314 8.3015H30.0289C27.3078 3.3535 22.0459 0 16.0002 0C11.5936 0 7.60389 1.78194 4.71045 4.664L7.00314 8.3015Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69839 23.6059C6.26002 25.0443 5.70414 26.2494 4.66345 27.2901C7.56064 30.1992 11.5697 32.0001 15.9998 32.0001C22.0833 32.0001 27.3736 28.6048 30.0796 23.6059H7.69839Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 4.64014C-1.56209 10.8885 -1.56209 21.0192 4.68628 27.2676C7.26834 24.6856 9.75166 22.2023 16 15.9539L4.68628 4.64014Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22055 15.9535C4.22055 13.6224 5.85886 11.6749 8.04661 11.1972C7.71036 11.1237 7.36148 11.0839 7.00311 11.0839C4.31367 11.0839 2.13354 13.2641 2.13354 15.9535C2.13354 18.6429 4.31367 20.8231 7.00311 20.8231C7.36142 20.8231 7.7103 20.7832 8.04661 20.7098C5.85886 20.232 4.22055 18.2846 4.22055 15.9535V15.9535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99306 11.7797L8.25212 12.5768H9.09025L8.41212 13.0695L8.67119 13.8666L7.99306 13.374L7.31494 13.8666L7.574 13.0695L6.89587 12.5768H7.734L7.99306 11.7797Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99306 13.8665L8.25212 14.6637H9.09025L8.41212 15.1563L8.67119 15.9535L7.99306 15.4608L7.31494 15.9535L7.574 15.1563L6.89587 14.6637H7.734L7.99306 13.8665Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99306 15.9534L8.25212 16.7506H9.09025L8.41212 17.2432L8.67119 18.0404L7.99306 17.5477L7.31494 18.0404L7.574 17.2432L6.89587 16.7506H7.734L7.99306 15.9534Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99306 18.0402L8.25212 18.8373H9.09025L8.41212 19.33L8.67119 20.1272L7.99306 19.6345L7.31494 20.1272L7.574 19.33L6.89587 18.8373H7.734L7.99306 18.0402Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComoros);
export default __webpack_public_path__ + "static/media/comoros.62ef0cda.svg";
export { ForwardRef as ReactComponent };